/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Archon_Players_MatchedInputs */



/**
* | output |
* | --- |
* | "{count} players matched" |
*
* @param {Archon_Players_MatchedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const archon_players_matched = /** @type {((inputs: Archon_Players_MatchedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archon_Players_MatchedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} joueurs correspondants`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} jugadores encontrados`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} jogadores encontrados`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} giocatori trovati`)
	return /** @type {LocalizedString} */ (`${i?.count} players matched`)
});